export class DatepickerConfig {
    public label: string;
    public outputFormat: string = 'yyyy-MM-dd';
    public cssClass: string;
}
